import { render } from "./paginater.vue?vue&type=template&id=f1489010"
import script from "./paginater.vue?vue&type=script&lang=js"
export * from "./paginater.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__